import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';


const Summary = (props) => {

    return (
        <div className='main'>
            <h1 className='title'>Summary Page</h1> 
        </div>

    );
};
export default Summary;
